import React from 'react';
import { getTimelineIcon } from '../utils/iconUtils';
import { formatEventDate, getStatusCodeDescription, getTemperatureClass, sortTimeline } from '../utils/orderDisplay';
import './OrderDetailsShared.css';

/** Travel History list. Events are { status, UpdatedOn, comments }. */
function OrderTimeline({
  events, loading, originAddress, destinationAddress,
  shipperTemp, consigneeTemp, haulTempMin, haulTempMax,
  className = '', style, itemClass = '',
}) {
  const sVal = shipperTemp != null ? String(shipperTemp).trim() : '';
  const cVal = consigneeTemp != null ? String(consigneeTemp).trim() : '';
  const rows = sortTimeline(events);

  return (
    <div className={`order-timeline ${className}`} style={style}>
      <h3 className={itemClass}>Travel History</h3>
      <div className="timeline-items">
        {loading ? (
          <div className={`timeline-item ${itemClass}`}>
            <div className="timeline-icon"><i className="fas fa-hourglass-half"></i></div>
            <div className="timeline-content"><h4>Loading...</h4></div>
          </div>
        ) : rows.length > 0 ? (
          rows.map((event, index) => {
            const detail =
              event.comments ||
              (['ARRSHIP', 'DEPSHIP'].includes(event.status) && originAddress) ||
              (['ARRCONS', 'DEPCONS'].includes(event.status) && destinationAddress) ||
              '';
            return (
              <div key={index} className={`timeline-item ${itemClass}`} style={{ '--i': Math.min(index, 10) + 1 }}>
                <div className="timeline-icon">{getTimelineIcon(event.status)}</div>
                <div className="timeline-content">
                  <h4>
                    {getStatusCodeDescription(event.status)}
                    {['ARRSHIP', 'DEPSHIP'].includes(event.status) && sVal && !isNaN(Number(sVal)) && (
                      <span className={`temperature ${getTemperatureClass(sVal, haulTempMin, haulTempMax)}`}>
                        {" "}@ {sVal}° F
                      </span>
                    )}
                    {['ARRCONS', 'DEPCONS'].includes(event.status) && cVal && !isNaN(Number(cVal)) && (
                      <span className={`temperature ${getTemperatureClass(cVal, haulTempMin, haulTempMax)}`}>
                        {" "}@ {cVal}° F
                      </span>
                    )}
                  </h4>
                  {detail ? <p>{detail}</p> : null}
                  <span className="timeline-time">{formatEventDate(event.UpdatedOn)}</span>
                </div>
              </div>
            );
          })
        ) : (
          <div className={`timeline-item ${itemClass}`}>
            <div className="timeline-icon"><i className="fas fa-info-circle"></i></div>
            <div className="timeline-content">
              <h4>Timeline Unavailable</h4>
              <p>Tracking information will appear here once available</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default OrderTimeline;
